import { FC } from "react"
import { scrollTo } from "../../helpers";
const Bonuses: FC = () => {

  return (
    <div className='container-fluid bonuses' id='bonuses'>
      <div className="row bonuses__image">
        <div className="content col-lg-10 col-md-6 col-sm-6 col-10">
          <p>Дарим бонусы всем клиентам</p>
          <button className="button" onClick={() => scrollTo('order')}>Заказать расчет</button>
        </div>
      </div>
    </div>
  )
}

export default Bonuses;
